{
  "add-new-contact": "Add new Contact",
  "hoa": "HOA",
  "reference":"# Reference",
  "routing":"Routing #",
  "account":"Account #",
  "no-items":"No Items Yet",
  "go-to-created-contact":"Go to created contact",
  "addEmailModalTitle": "Add Email",
  "emailAddressLabel": "Email Address",
  "kindLabel": "Kind",
  "loginEmailHelperText": "The Login type email must be added in the access section.",
  "managePermissionsModalTitle": "Manage Permissions",
  "addButton": "Add",
  "permissionElementLabel": "Permission Element",
  "accessInformationLabel": "Access Information",
  "updateInformationLabel": "Update Information",
  "roleLabel": "Role",
  "addAccountModalTitle": "Add Account",
  "accountNumberLabel": "Account Number",
  "bankLabel": "Bank",
  "bankAddressLabel": "Bank Address",
  "countryLabel": "Country",
  "accountNameLabel": "Account Name",
  "routingNumberLabel": "Routing Number",
  "addLicenseModalTitle": "Add License",
  "numberLabel": "Number",
  "stateLabel": "State",
  "addAccessModalTitle": "Add Access",
  "addPhoneModalTitle": "Add Phone",
  "addAddressModalTitle": "Add Address",
  "streetAddressLabel": "Street Address",
  "zipCodeLabel": "Zip Code",
  "countyLabel": "County",
  "cityLabel": "City",
  "referenceLabel": "Reference",
  "generalInformationTitle": "General Information",
  "notificationsTitle": "Notifications",
  "addressesTitle": "Addresses",
  "phonesTitle": "Phones",
  "emailsTitle": "Emails",
  "licensesTitle": "Licenses",
  "accountsTitle": "Accounts",
  "relationsTitle": "Relations",
  "accessTitle": "Access",
  "permissionsTitle": "Permissions",
  "noInformationAvailableMessage": "No Information available",
  "passwordRecoveryButton": "password recovery",
  "emailLabel": "Email",
  "loadingText": "loading",
  "titleCompanyAlert": "Title company",
  "deleteAddressTitle": "Delete Address",
  "deleteAddressMessage": "Are you sure to delete {{address}}?",
  "deleteNumberTitle": "Delete Number",
  "deleteNumberMessage": "Are you sure to delete {{number}}?",
  "deleteEmailTitle": "Delete Email",
  "deleteEmailMessage": "Are you sure to delete {{email}}?",
  "deleteLicenseTitle": "Delete License",
  "deleteLicenseMessage": "Are you sure to delete {{license}}?",
  "deleteAccountTitle": "Delete Account",
  "deleteAccountMessage": "Are you sure to delete {{account}} from bank {{bank}}?",
  "deleteAssociationTitle": "Delete Association",
  "deleteAssociationParentMessage": "Are you sure to delete the association {{kind}} on {{name}}?",
  "deleteAssociationSubordinateMessage": "Are you sure to delete the association {{name}} as {{kind}}?",
  "deleteAccessTitle": "Delete Access",
  "deleteAccessMessage": "Are you sure to delete the email access?",
  "grid-view": "Grid view",
  "list-view": "List view",
  "add-organization": "Add Organization",
  "add-person": "Add Person",
  "searching": "Searching contacts…",
  "no-results": "No contacts match \"{{text}}\"",
  "search-error": "We couldn't load contacts. Please try again.",
  "saving": "Saving…",
  "relation-on": "On {{name}}",
  "relation-as": "As {{kind}}",
  "ai-usage-title": "AI Usage",
  "ai-usage-details": "AI usage details",
  "reset-ai-counters": "Reset counters",
  "reset-ai-counters-success": "AI counters reset"
}
